<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.47266 4.5H10.0449C10.131 4.50003 10.2608 4.53149 10.4023 4.60742C10.5422 4.68251 10.6583 4.78169 10.7275 4.87695L12.7246 7.62402C12.8701 7.8238 12.8705 8.17513 12.7246 8.37598L10.7275 11.123H10.7266C10.6574 11.2182 10.5421 11.3176 10.4023 11.3926C10.2608 11.4685 10.1309 11.5 10.0449 11.5L3.47266 11.499C3.36665 11.499 3.16699 11.3751 3.16699 11.0762V4.92285C3.16706 4.624 3.36667 4.5 3.47266 4.5Z"
    />
  </svg>
</template>
